import { __assign } from "tslib";
import { defaults } from './utils';
var deprecated = ['pid', 'section', 'errorFieldName'];
var getBookingAction = function () {
    var _a, _b;
    return (_b = (_a = window.B) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.b_action;
};
var getBookingPageviewId = function () {
    var _a, _b;
    return (_b = (_a = window.B) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.pageview_id;
};
var ErrorReporter = /** @class */ (function () {
    function ErrorReporter(options) {
        var _this = this;
        options = options || {};
        if (process.env.NODE_ENV !== 'production') {
            if (Object.keys(options).some(function (key) { return deprecated.indexOf(key) !== -1; })) {
                console.warn("[error-reporter] Props [".concat(deprecated.join(', '), "] have been deprecated, see the latest changelog"));
            }
        }
        var finalOptions = defaults(options, {
            endpoint: '/js_errors',
            maxErrorsToReport: 5,
            payloadContentType: 'multipart/form-data',
            requestHeaders: {},
            handleWindowErrors: false,
            transform: defaultTransformer,
            logError: function (error) {
                var body = _this.buildPayload(error);
                var headers = _this.contentType === 'application/json'
                    ? __assign(__assign({}, _this.requestHeaders), { 'Content-Type': _this.contentType }) : __assign({}, _this.requestHeaders);
                window
                    .fetch(_this.endpoint, {
                    method: 'POST',
                    body: body,
                    headers: headers
                })
                    .catch(function () { return false; });
            }
        });
        this.errorsReportedSoFar = 0;
        this.errorStack = [];
        this.maxErrorsToReport = finalOptions.maxErrorsToReport;
        this.endpoint = finalOptions.endpoint;
        this.contentType = finalOptions.payloadContentType;
        this.requestHeaders = finalOptions.requestHeaders;
        this.transform = finalOptions.transform;
        this.logError = finalOptions.logError;
        if (finalOptions.handleWindowErrors) {
            window.addEventListener('error', function (event) {
                return _this.sendError({
                    name: event.message,
                    stack: event.error && event.error.stack,
                    message: event.error && event.error.message,
                    url: event.filename,
                    lno: event.lineno,
                    colno: event.colno
                });
            });
        }
    }
    ErrorReporter.prototype.buildPayload = function (error) {
        var contentType = this.contentType;
        switch (contentType) {
            case 'application/json':
                return JSON.stringify(error);
            case 'multipart/form-data':
            default:
                var errorPayload_1 = new window.FormData();
                Object.keys(error).forEach(function (key) {
                    errorPayload_1.append(key, error[key]);
                });
                return errorPayload_1;
        }
    };
    ErrorReporter.prototype.sendError = function (error) {
        if (this.errorStack.length > 0) {
            console.error('[error-reporter] The last error was produced while an error was being logged');
            return false;
        }
        var genericError = error instanceof Error
            ? {
                message: error.message,
                stack: error.stack,
                name: error.name,
                colno: 0,
                lno: 0,
                url: document.location.href
            }
            : error;
        this.errorsReportedSoFar = this.errorsReportedSoFar + 1;
        if (this.errorsReportedSoFar > this.maxErrorsToReport) {
            return false;
        }
        var transformedError = this.transform(genericError);
        if (transformedError === null) {
            // Error could have changed to null by the transformer to prevent being reported
            return false;
        }
        this.errorStack.push(genericError);
        this.logError(transformedError);
        this.errorStack.pop();
        return true;
    };
    Object.defineProperty(ErrorReporter.prototype, "setErrorsReportedSoFar", {
        set: function (value) {
            this.errorsReportedSoFar = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ErrorReporter.prototype, "setRequestHeaders", {
        set: function (value) {
            this.requestHeaders = value;
        },
        enumerable: false,
        configurable: true
    });
    return ErrorReporter;
}());
export default ErrorReporter;
export function affiliateTransformer(error) {
    var action = getBookingAction();
    return __assign({ error: error.name, lno: error.lno || 0, colno: error.colno || 0, pid: getBookingPageviewId() || 1, url: error.url || document.location.href }, (action
        ? {
            ref_action: action
        }
        : {}));
}
export function nodeJSTransformer(error) {
    var action = getBookingAction();
    return {
        column: error.colno || 0,
        line: error.lno || 0,
        stack: error.stack || '',
        message: error.message || '',
        file: error.url || document.location.href,
        errc: 0,
        errp: 0,
        ref_action: action || '',
        url: document.location.href
    };
}
export function defaultTransformer(error, action, pageviewId) {
    var result = __assign(__assign({}, affiliateTransformer(error)), { be_running: 1, be_column: error.colno || 0, be_line: error.lno || 0, be_stack: error.stack || '', be_message: error.message || '', be_file: error.url || document.location.href });
    var actionName = action !== null && action !== void 0 ? action : getBookingAction();
    if (actionName) {
        result.ref_action = actionName;
    }
    result.pid = pageviewId !== null && pageviewId !== void 0 ? pageviewId : result.pid;
    return result;
}
//# sourceMappingURL=index.js.map